import { createSelector } from 'reselect'
import { RootState } from '../root.reducer'

const rootApplicationSearch = (state) => state.applicationSearch

export const getApplicationSearchData = (instanceName: string) => {
  return createSelector([rootApplicationSearch], (applicationSearch) => applicationSearch.data?.[instanceName])
}
export const getApplicationSeachLoading = createSelector(
  [rootApplicationSearch],
  (applicationSearch) => applicationSearch.status === 'loading',
)

export const getApplicationsCount = (state, { instanceName }) => {
  const res = state.applicationSearch.data?.[instanceName]
  return res?.length || 0
  // console.log(data)
}

export const appsFetchingSelector = () => {
  return createSelector([rootApplicationSearch], (applicationSearch) => applicationSearch.status === 'pending')
}

export const appsFetchSucceded = (state: RootState) => {
  return state.applicationSearch.status === 'loaded'
}
